import { i18n, Messages } from '@lingui/core';
import {
  detect,
  fromCookie,
  fromNavigator,
  fromStorage,
} from '@lingui/detect-locale';

import { appDB } from '../../features/db/app-db';
import { setCurrentLang } from '../../features/db/lang';

export type Langs = 'ru' | 'hy' | 'en';

const DEFAULT_FALLBACK = () => 'en';
const STORAGE_KEY = 'lang';

export const detectLang = () => {
  const detected = detect(
    fromStorage(STORAGE_KEY),
    fromCookie(STORAGE_KEY),
    fromNavigator(),
    DEFAULT_FALLBACK
  );

  const [result] = detected?.split('-') ?? DEFAULT_FALLBACK();

  return result as Langs;
};

const setCookie = (lang: Langs) => {
  document.cookie = `${STORAGE_KEY}=${lang}; path=/`;
};

const setStorage = (lang: Langs) => {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {
    //
  }
};

export const setLang = (lang: Langs) => {
  setCookie(lang);
  setStorage(lang);

  i18n.activate(lang);
};

export const initLocal = (locals: Record<Langs, Messages>) => {
  Object.entries(locals).forEach(([key, value]) => {
    i18n.load(key, value);
  });

  const lang = detectLang();

  i18n.activate(lang);

  setCurrentLang(appDB, lang);
};

export const changeLocal = (lang: Langs) => {
  i18n.activate(lang);
};

const lastLang = detectLang();

i18n.on('change', () => {
  const lang = detectLang();
  if (lang === lastLang) return;

  setCurrentLang(appDB, lang);
});
